module.exports = __webpack_public_path__ + "img/Cart-Plus.4f904501.svg";